import { useEffect } from 'react';

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schemas?: Record<string, unknown>[];
}

export function useSEO(data: SEOData) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = data.title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', data.description);
    setMeta('keywords', data.keywords);
    setMeta('og:title', data.title, true);
    setMeta('og:description', data.description, true);
    setMeta('og:url', data.canonicalUrl, true);
    setMeta('og:type', data.ogType || 'website', true);
    setMeta('og:site_name', '漫画之家', true);
    setMeta('og:locale', 'zh_CN', true);
    if (data.ogImage) setMeta('og:image', data.ogImage, true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', data.title);
    setMeta('twitter:description', data.description);
    if (data.ogImage) setMeta('twitter:image', data.ogImage);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', data.canonicalUrl);

    const scriptId = 'structured-data';
    let oldScript = document.getElementById(scriptId);
    if (oldScript) oldScript.remove();

    if (data.schemas && data.schemas.length > 0) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(
        data.schemas.length === 1 ? data.schemas[0] : data.schemas
      );
      document.head.appendChild(script);
    }

    return () => {
      document.title = prevTitle;
    };
  }, [data]);
}